import React from 'react';

export function stopPropagationAndPreventDefault(
  e: Event | React.MouseEvent | React.KeyboardEvent,
) {
  e?.stopPropagation();
  e?.preventDefault();
}
